import React from "react";
import { Skeleton } from "@mui/material";

import { useTranslation } from "@helpers/translate";
import HistoryIdIcon from "@assets/icons/HistoryIdIcon.jsx";

import {
  formatWalletTxDateTime,
  formatWalletTxBonusDisplay,
} from "../../../../../helpers/walletTxFormat";
import { getWalletTxStatusModifier } from "../../../../../helpers/walletTxStatus";

import "./WalletTxMobileCards.sass";

const WalletTxMobileCards = ({ data, loading }) => {
  const { __ } = useTranslation();

  const typeLabel = (el) =>
    el.operation === "deposit"
      ? __("wallet.deposit_type")
      : __("wallet.withdraw_type");

  if (loading) {
    return (
      <div className="wallet-tx-table__mobile">
        {[1, 2, 3].map((item) => (
          <div key={item} className="wallet-tx-card wallet-tx-card--skeleton">
            <Skeleton variant="rounded" height={132} sx={{ width: "100%" }} />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="wallet-tx-table__mobile">
      {data.map((el) => (
        <article key={el.id} className="wallet-tx-card">
          <div className="wallet-tx-card__header">
            <div>
              <div className="wallet-tx-card__id">
                <HistoryIdIcon />
                {el.id}
              </div>
              <div
                className={`wallet-tx-status-badge wallet-tx-status-badge--${getWalletTxStatusModifier(
                  el.status,
                )}`}
              >
                {el.status}
              </div>
            </div>

            <div className="wallet-tx-card__date-block">
              <span className="wallet-tx-card__label">{__("common.date")}</span>
              <span className="wallet-tx-card__value--date">
                {formatWalletTxDateTime(el.created_at)}
              </span>
            </div>
          </div>

          <div className="wallet-tx-card__meta">
            <div className="wallet-tx-card__meta-cell">
              <span className="wallet-tx-card__label">{__("common.type")}</span>
              <span className="wallet-tx-card__value">{typeLabel(el)}</span>
            </div>
            <div className="wallet-tx-card__meta-cell">
              <span className="wallet-tx-card__label">
                {__("wallet.history_table.bonus_short")}
              </span>
              <span className="wallet-tx-card__value">
                {formatWalletTxBonusDisplay(el.bonus_amount, el.currency)}
              </span>
            </div>
            <div className="wallet-tx-card__meta-cell">
              <span className="wallet-tx-card__label">
                {__("common.amount")}
              </span>
              <span className="wallet-tx-card__value">
                {el.amount} {el.currency}
              </span>
            </div>
            <div className="wallet-tx-card__meta-cell wallet-tx-card__meta-cell--method">
              <span className="wallet-tx-card__label">
                {__("common.method")}
              </span>
              <span className="wallet-tx-card__value">
                {el.gateway_title || "—"}
              </span>
            </div>
          </div>
        </article>
      ))}
    </div>
  );
};

export default WalletTxMobileCards;
